import Vue from 'vue';
import api from '../api';
import axios from 'axios';
const isServer = Vue.prototype.$isServer;
import VueCookie from 'vue-cookie';

export const IsPC = () => {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"
    ];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}
export const isIos = () => {
    if (isServer) return;
    const u = navigator.userAgent,
        app = navigator.appVersion;
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || !!u.match(/\(Macintosh;/);
}
export const isAndroid = () => {
    if (isServer) return;
    const u = navigator.userAgent,
        app = navigator.appVersion;
    return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
}
export const delObj = (obj, target) => {
        target.forEach((item) => {
            if (obj.hasOwnProperty(item)) {
                delete obj[item]
            }
        })
        return obj;
    }
    // 微信分享
export const wxShare = () => {
    /**
     *  TODO：获取微信活动配置
     */

    var url = location.href.split('#')[0];
    var _url = encodeURIComponent(url); //url编码
    let params = {
        url: _url
    };
    axios.get(api.getWxConfig, {
        params: params
    }).then(
        (res) => {
            wx.config({
                debug: false,
                appId: res.result.appId,
                timestamp: res.result.timestamp,
                nonceStr: res.result.nonceStr,
                signature: res.result.signature,
                jsApiList: [
                    'checkJsApi',
                    'updateTimelineShareData',
                    'updateAppMessageShareData',
                    'onMenuShareAppMessage',
                    'onMenuShareTimeline'
                ]
            });

            wx.ready(function() {
                var link = window.location.href;
                //分享朋友圈
                wx.updateTimelineShareData({
                    title: '考满分路上的奋斗清单',
                    link: link,
                    desc: '你的努力，我都看得见!',
                    imgUrl: 'https://image.kmf.com/test-da-image/e6/4a/e64ab49dfc216d0ae932cf19d3d78897.png',
                    success: function() {
                        // 用户点击了分享后执行的回调函数
                    },
                });
                //发送给朋友
                wx.updateAppMessageShareData({
                    title: '考满分路上的奋斗清单',
                    desc: '你的努力，我都看得见!',
                    link: link,
                    imgUrl: 'https://image.kmf.com/test-da-image/e6/4a/e64ab49dfc216d0ae932cf19d3d78897.png',
                    success: function() {
                        // 用户点击了分享后执行的回调函数
                    }
                });
            })

        }
    )

}

//setCookies

export const setCookies = (key, value) => {
    VueCookie.set(key, value, {
        domain: ".kmf.com",
        path: '/'
    });
    

}
export const getCookies = (key) => {
    return VueCookie.get(key);

}